<template>
    <div class="title" ref="title">
        <transition name="pic" appear>
            <img :src="require('@/assets/joinus/页面5-1.png')" class="pic">
        </transition>

        <transition name="text" appear>
            <div class="content">
                <div class="titleText">加入我们</div>
                <div class="contentArea">
                    <div class="left">
                        <div class="up">
                            <p
                                style="text-align: center;font-weight: bold;margin-bottom: 5%;color: white;font-size: 32px;">
                                需求专业</p>
                            <p>1. 航空宇航推进理论与工程、航空航天工程等相关专业</p>
                            <p>2. 仿真计算、流体力学、传热等相关专业</p>
                            <p>3. 动力工程及工程热物理、能源动力等相关专业</p>
                            <p>4. 电气工程、自动化、测控技术等相关专业</p>
                            <p>5. 机械设计及制造等相关专业</p>
                        </div>
                        <el-divider></el-divider>
                        <div class="down">
                            <p
                                style="text-align: center;font-weight: bold;margin-bottom: 5%;color: white;font-size: 32px;">
                                招聘对象</p>
                            <p>1. 校园招聘：应届毕业生全日制本科、硕士/博士研究生</p>
                            <p>2. 社会招聘：具有相关经验的专业技术人员</p>
                            <p>3. 热爱航天航空事业、遵纪守法、身体健康</p>
                            <p>4. 专业能力优秀、综合素质高、沟通能力强</p>
                        </div>
                    </div>
                    <el-divider direction="vertical"></el-divider>
                    <div class=" right">
                        <div>
                            <p
                                style="text-align: center;font-weight: bold;margin-bottom: 5%;color: white;font-size: 32px;">
                                薪酬福利</p>
                            <p class="childTitle">薪酬竞争力MAX</p>
                            <p>薪酬丰厚，奖金满满，让你的小金库持续膨胀，收获感爆棚！</p>
                            <p class="childTitle">成长加速，未来可期</p>
                            <p>一对一导师引领，多路径晋升畅通无阻；已设立博士后科研工作站，拥有丰富学术资源、前沿科研项目，职业发展空间无限大！</p>
                            <p class="childTitle">福利满满，生活无忧</p>
                            <p>五险一金全保障；餐补福利暖心间、健康体检常相伴；带薪年假轻松享，工会关怀乐不停！</p>
                            <p class="childTitle">人文关怀，温馨如家</p>
                            <p>零食下午茶，生日结婚慰问都有礼，关怀备至暖人心！</p>
                            <p class="childTitle">活力文娱，快乐工作</p>
                            <p>运动健身设施全，团建活动常组织，健康活力每一天！</p>
                        </div>
                        <div class="Contact">
                            <p class="contactText">投递邮箱：hr@thupower.com.cn</p>
                            <p class="remarkText">欲了解更多岗位详情，欢迎访问智联招聘和BOSS直聘平台在线投递</p>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>


</template>

<script>
export default {
    data() {
        return {
        }
    },
    mounted(){
        this.scrollToDistance()
    },
    methods: {
        scrollToDistance() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.title {
    height: 100vh;
    width: 100%;
    background-color: rgba(79,79,79);
    position: relative;
    font-family: QHKT;
    
    .pic {
        position: absolute;
        width: 100%;
        height: 100%;
        // left: 10%;
        // right: 10%;
        opacity: 0.2;
        z-index: 1
    }

    .content {
        position: absolute;
        height: 90%;
        width: 90%;
        margin: 5% 5%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        z-index: 2;
        color: white;

        .titleText {
            font-size: 60px;
            text-align: center;
            font-weight: bold;
            color: rgb(255, 255, 255)
        }

        .contentArea {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            height: 85%;
            font-size: 25px;

            .left {
                width: 42%;
                margin-right: 7%;

                .el-divider {
                    height: 3px;
                    width: 95%;
                    margin: 10% 0;
                    background-color: rgb(255, 255, 255);
                }
            }

            .el-divider {
                margin-top: 3%;
                width: 3px;
                height: 90%;
                background-color: rgb(255, 255, 255);
            }

            .right {
                width: 42%;
                margin-left: 7%;
                .childTitle {
                    font-weight: bold;
                    margin-top: 2vh;
                }

                .Contact{
                    width: 100%;
                    margin-top: 5vh;
                    text-align: right;
                    color: rgb(255, 255, 255);
                    font-weight: bold;
                    .contactText{
                        width: 60%;
                        margin-left: 40%;
                        text-align: left;
                    }
                    .remarkText{
                        width: 80%;
                        margin-left: 30%;
                        text-align: left;
                        font-size: 16px;
                    }
                }
            }
        }
    }
}

.pic-enter-active {
    animation: bounce-in 2s;
}

.pic-enter {
    opacity: 0;
}

.text-enter-active {
    animation: text-bounce-in 2s;
}

.text-enter {
    opacity: 0;
}

@keyframes bounce-in {
    0% {
        transform: scale(0.8);
    }

    100% {
        transform: scale(1);
    }
}


@keyframes text-bounce-in {
    0% {
        opacity: 0.1;
    }

    100% {
        opacity: 1
    }
}
</style>
